import React, { useEffect, useState } from "react";

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    const ios =
      /iphone|ipod/i.test(navigator.userAgent) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

    const standalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;

    setIsIOS(ios);
    setIsStandalone(standalone);

    // ---------- ANDROID ----------
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowBanner(true);
    };

    window.addEventListener(
      "beforeinstallprompt",
      handleBeforeInstallPrompt
    );

    // ---------- iOS (iPhone + iPad) ----------
    if (ios && !standalone) {
      setTimeout(() => {
        setShowBanner(true);
      }, 2000);
    }

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    await deferredPrompt.userChoice;

    setDeferredPrompt(null);
    setShowBanner(false);
  };

  const handleClose = () => {
    setShowBanner(false);
    // Beim Testen besser deaktiviert lassen
    // localStorage.setItem("installPromptDismissed", "true");
  };

  // ---------- FINAL GUARD ----------
  if (!showBanner || isStandalone) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        background: "#1d1d1d",
        color: "white",
        padding: "14px 16px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        zIndex: 10000,
        boxShadow: "0 -2px 10px rgba(0,0,0,0.3)",
        fontFamily: "system-ui, -apple-system, BlinkMacSystemFont",
      }}
    >
      {!isIOS ? (
        <>
          <span>📱 App installieren für schnellen Zugriff</span>
          {deferredPrompt && (
            <button
              onClick={handleInstallClick}
              style={{
                background: "#007bff",
                border: "none",
                color: "white",
                padding: "8px 14px",
                borderRadius: "6px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              Installieren
            </button>
          )}
        </>
      ) : (
        <>
          <span style={{ lineHeight: 1.4 }}>
            📲 App installieren:<br />
            <strong>Teilen</strong> →{" "}
            <strong>„Zum Home-Bildschirm“</strong>
          </span>
          <button
            onClick={handleClose}
            style={{
              background: "transparent",
              border: "none",
              color: "white",
              fontSize: "22px",
              cursor: "pointer",
            }}
          >
            ×
          </button>
        </>
      )}
    </div>
  );
};

export default InstallPrompt;
